function Footer() {
  return (
    <footer className="footer-component">
      <p>Built by: Keshav Chakravarthy</p>
    </footer>
  );
}

export default Footer;
